<template>
    <BaseCard
        as="button"
        type="button"
        padding="sm"
        :selected="selected"
        class="w-full flex items-center gap-4 text-left text-ink"
        :aria-pressed="selected"
        @click="$emit('toggle')">
        <BaseCheckbox :model-value="selected" indicator class="shrink-0" />

        <div class="flex items-center gap-3 grow min-w-0">
            <CalendarAttendeeAvatar size="md" :name="person.name" :email="person.email" />

            <div class="flex flex-col gap-1 min-w-0 grow">
                <div class="flex items-center gap-2 flex-wrap">
                    <span class="body-small-semibold truncate">{{ person.name }}</span>
                    <BaseChip v-if="person.has_public_profile" size="2xs" class="max-w-full whitespace-normal h-auto min-h-5.5">
                        <i class="bi text-[10px]" :class="COLLABORATION_PROFILE_BOOTSTRAP_ICON_CLASS" aria-hidden="true"></i>
                        {{ t("connections.calendarImport.card.publicProfile") }}
                    </BaseChip>
                    <BaseChip v-else size="2xs" class="max-w-full whitespace-normal h-auto min-h-5.5">
                        <i class="bi bi-lock text-[10px]" aria-hidden="true"></i>
                        {{ t("connections.calendarImport.card.noProfile") }}
                    </BaseChip>
                </div>
                <div class="flex items-center gap-2 text-ink-muted">
                    <span v-if="person.title" class="body-small truncate">{{ person.title }}</span>
                    <span v-else class="body-small truncate">{{ person.email }}</span>
                </div>
            </div>
        </div>

        <div class="shrink-0">
            <span class="body-small-semibold text-ink-muted">{{ t("connections.calendarImport.card.meetingCount", { count: person.meeting_count }, person.meeting_count) }}</span>
        </div>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import BaseChip from "~vue/components/BaseChip.vue";
import CalendarAttendeeAvatar from "~vue/components/CalendarAttendeeAvatar.vue";
import BaseCheckbox from "~vue/components/form/BaseCheckbox.vue";
import { COLLABORATION_PROFILE_BOOTSTRAP_ICON_CLASS } from "~vue/components/navigation/menuPanes";
import type { CalendarPerson } from "~vue/types/connection";
import { useI18n } from "vue-i18n";

defineProps<{
    person: CalendarPerson;
    selected: boolean;
}>();

defineEmits<{
    toggle: [];
}>();

const { t } = useI18n();
</script>
